<!-- @format -->

<template>
	<el-row :gutter="8">
		<template v-for="item in widgetDatas" :key="item.code">
			<template v-if="item.category === 'container'">
				<el-col v-show="!item.pcProps.hidden" :span="+item.pcProps.cols" class="form-render-col">
					<!-- label为透传给form-item组件的属性 -->
					<component
						:is="getWidgetName(item.type, name)"
						v-model="formDatas[item.pcProps.code!]"
						:item="item"
						class="form-render-container"
					>
						<template #default="scope">
							<form-widget-render
								v-if="scope && scope.data"
								v-model="formDatas"
								:widget-datas="scope.data.children"
								:hidden="item.pcProps.hidden"
							/>
							<form-widget-render
								v-else
								v-model="formDatas"
								:widget-datas="item.children"
								:hidden="item.pcProps.hidden"
							/>
						</template>
					</component>
				</el-col>
			</template>
			<template v-else>
				<el-col v-show="!item.pcProps.hidden" :span="+item.pcProps.cols">
					<widget-form-item
						v-show="item.type !== 'placeholder'"
						v-model="formDatas[item.pcProps.code!]"
						:prop="item.pcProps.code"
						:type="item.type"
						:pc-props="item.pcProps"
						:item="item"
						:hidden="hidden"
					/>
				</el-col>
			</template>
		</template>
	</el-row>
</template>

<script setup lang="ts">
	import WidgetFormItem from '../components/widget-form-item/index.vue';
	import { getWidgetName } from '../components/widget-field';
	import type { FieldsType } from '../types';

	interface Props {
		modelValue: Record<string, string>;
		widgetDatas: FieldsType[];
		disabled?: boolean;
		hidden?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		disabled: false,
	});

	const emit = defineEmits(['update:modelValue']);

	const name = inject<string>('name');

	const formDatas = computed({
		get() {
			return props.modelValue || {};
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped lang="scss">
	.form-render-col {
		margin-bottom: 5px;
	}
</style>
